import React, { useMemo, useRef, useState } from "react";
import TranslationWrapper, { getTranslation } from "../../../../components/TranslationWrapper/TranslationWrapper.tsx";
import { Card, GridLegacy } from "@mui/material";
import CardBody from "../../../../components/Card/CardBody";
import Buttonbar from "../LightspeedK/Components/Buttonbar";
import ButtonbarAccounts from "../LightspeedK/Components/ButtonbarAccounts";
import ButtonbarHeaders from "../LightspeedK/Components/ButtonbarHeaders";
import { convertObjectToSelectOptions } from "../../../../templateHelpers";
import Overzicht from "../LightspeedK/Components/Overzicht";
import OverzichtAccounts from "../LightspeedK/Components/OverzichtAccounts";
import OverzichtHeaders from "../LightspeedK/Components/OverzichtHeaders";
import MenuSyncSettings from "../MenuSyncSettings";
import Method from "../LightspeedK/InputForms/Method";
import Accounts from "../LightspeedK/InputForms/Accounts";
import Headers from "../LightspeedK/InputForms/Headers";
import FormSwitchTC from "../../../../components/Forms/FormSwitchTC";
import FormTextTC from "../../../../components/Forms/FormTextTC";
import FormSelectTC from "../../../../components/Forms/FormSelectTC";
import FormAsyncTC from "../../../../components/Forms/FormAsyncTC";
import { useController, useFormContext } from "react-hook-form";
import FormJson from "../../../../components/Forms/FormJson";

function Bork() {
  const [showInputForm, setShowInputForm] = useState(false);
  const [showInputFormAccounts, setShowInputFormAccounts] = useState(false);
  const [showInputFormHeaders, setShowInputFormHeaders] = useState(false);
  const form = useRef(null);
  const formAccounts = useRef(null);
  const formHeaders = useRef(null);
  const {
    field: { value: extra_settings__paymentApiIdsValue, onChange: extra_settings__paymentApiIdsOnChange },
  } = useController({ name: "extra_settings__paymentApiIds" });
  const {
    field: { value: extra_settings__account_to_pricekey, onChange: extra_settings__account_to_pricekeyOnChange },
  } = useController({ name: "extra_settings__account_to_pricekey" });
  const {
    field: { value: extra_settings__account_headers, onChange: extra_settings__account_headersOnChange },
  } = useController({ name: "extra_settings__account_headers" });

  /**
   * Payment IDS
   */
  const handleButtonClick = (type) => {
    form.current = getInputForm(type);
    setShowInputForm(true);
  };

  const handleCloseClick = () => {
    form.current = null;
    setShowInputForm(false);
  };

  const onDelete = (objectToDelete) => {
    extra_settings__paymentApiIdsOnChange(
      JSON.stringify(JSON.parse(extra_settings__paymentApiIdsValue).filter((obj) => obj.name !== objectToDelete.name))
    );
  };

  /**
   * Account Mapping
   */
  const handleButtonAccountsClick = (type) => {
    formAccounts.current = getInputForm(type);
    setShowInputFormAccounts(true);
  };

  const handleCloseAccountsClick = () => {
    formAccounts.current = null;
    setShowInputFormAccounts(false);
  };

  const onDeleteAccounts = (objectToDelete) => {
    extra_settings__account_to_pricekeyOnChange(
      JSON.stringify(JSON.parse(extra_settings__account_to_pricekey).filter((obj) => obj.name !== objectToDelete.name))
    );
  };

  /**
   * Account Mapping Headers Account Server
   */
  const handleButtonHeadersClick = (type) => {
    formHeaders.current = getInputForm(type);
    setShowInputFormHeaders(true);
  };

  const handleCloseHeadersClick = () => {
    formHeaders.current = null;
    setShowInputFormHeaders(false);
  };

  const onDeleteHeaders = (objectToDelete) => {
    extra_settings__account_headersOnChange(
      JSON.stringify(JSON.parse(extra_settings__account_headers).filter((obj) => obj.name !== objectToDelete.name))
    );
  };

  const getInputForm = (type, value = undefined) => {
    let form = null;
    let action = "ADD";
    if (value !== undefined) {
      action = "EDIT";
    }

    switch (type) {
      case "method":
        form = (
          <Method
            closeForm={handleCloseClick}
            methods={extra_settings__paymentApiIdsValue ? JSON.parse(extra_settings__paymentApiIdsValue) : []}
            onSave={(value) => {
              const arr = extra_settings__paymentApiIdsValue ? JSON.parse(extra_settings__paymentApiIdsValue) : [];
              if (action === "ADD") {
                arr.push(value);
              } else if (action === "EDIT") {
                arr.forEach((obj, key) => {
                  if (obj.name === value.oldName) {
                    delete value.oldName;
                    arr[key] = value;
                  }
                });
              }
              extra_settings__paymentApiIdsOnChange(JSON.stringify(arr));
            }}
            value={value}
          />
        );
        break;
      case "accounts":
        form = (
          <Accounts
            closeForm={handleCloseAccountsClick}
            methods={extra_settings__account_to_pricekey ? JSON.parse(extra_settings__account_to_pricekey) : []}
            onSave={(value) => {
              const arr = extra_settings__account_to_pricekey ? JSON.parse(extra_settings__account_to_pricekey) : [];
              if (action === "ADD") {
                arr.push(value);
              } else if (action === "EDIT") {
                arr.forEach((obj, key) => {
                  if (obj.name === value.oldName) {
                    delete value.oldName;
                    arr[key] = value;
                  }
                });
              }
              extra_settings__account_to_pricekeyOnChange(JSON.stringify(arr));
            }}
            value={value}
          />
        );
        break;
      case "headers":
        form = (
          <Headers
            closeForm={handleCloseHeadersClick}
            methods={extra_settings__account_headers ? JSON.parse(extra_settings__account_headers) : []}
            onSave={(value) => {
              const arr = extra_settings__account_headers ? JSON.parse(extra_settings__account_headers) : [];
              if (action === "ADD") {
                arr.push(value);
              } else if (action === "EDIT") {
                arr.forEach((obj, key) => {
                  if (obj.name === value.oldName) {
                    delete value.oldName;
                    arr[key] = value;
                  }
                });
              }
              extra_settings__account_headersOnChange(JSON.stringify(arr));
            }}
            value={value}
          />
        );
        break;
    }

    return form;
  };

  const closeMethodOptions = useMemo(() => {
    const closeMethod = [
      { value: "table", label: "Op Tafel" },
      { value: "ticket", label: "Op Ticket" },
      { value: "delivery", label: "Delivery" },
      { value: "queue", label: "Ticket Queue" },
    ];

    return convertObjectToSelectOptions(closeMethod);
  }, []);

  const vatOptions = useMemo(() => {
    const vatMethod = [
      { value: "1", label: "Group 1 (default)" },
      { value: "2", label: "Group 2" },
    ];

    return convertObjectToSelectOptions(vatMethod);
  }, []);

  const {
    field: { value: useAccountServerValue, onChange: useAccountServerValueOnChange },
  } = useController({ name: "useAccountServer" });

  const { menukaartVestigingId } = useFormContext();
  return (
    <div style={{ height: "100%", width: "100%", overflow: "hidden" }}>
      <Card>
        <CardBody alignItems={"flex-start"} style={{ padding: 16, display: "flex", flexWrap: "wrap" }}>
          <GridLegacy container spacing={1} style={{ maxWidth: 1400 }}>
            <GridLegacy item xs={12}>
              <h3>
                <TranslationWrapper
                  tDefault={"Bork / Trivec lite"}
                  tKey={"vestigingen.form.bork.headers.borktriveclite"}
                />
              </h3>
            </GridLegacy>
            <FormSwitchTC
              name={"useAccountServer"}
              tDefault={"Use account server"}
              tKey={"vestigingen.form.bork.label.useAccountServer"}
            />
            <FormSwitchTC
              name={"useAccountServer_input"}
              tDefault={"Use account server manual input"}
              tKey={"vestigingen.form.bork.label.useAccountServer_input"}
            />
            <FormTextTC
              name={"apiaccounts__borkLiteAccountUrl"}
              tDefault={"Account DB Url"}
              tKey={"vestigingen.form.bork.label.accountDbUrl"}
            />
            <FormSelectTC
              name={"apiaccounts__borkCloseMethod"}
              options={closeMethodOptions}
              tDefault={"Close method"}
              tKey={"vestigingen.form.bork.label.borkCloseMethod"}
            />
            <FormTextTC
              name={"apiaccounts__borkLiteURL"}
              rules={{
                validate: (v) => {
                  const isProd = import.meta.env.PROD;
                  if (isProd && v.length > 0 && !v.startsWith("https://")) {
                    return getTranslation(
                      "vestigingen.form.bork.validation.borkLiteURL",
                      "Make sure your URL starts with `https://`"
                    );
                  }
                  return true;
                },
              }}
              tDefault={"Lite Server"}
              tKey={"vestigingen.form.bork.label.borkLiteURL"}
            />
            <FormTextTC
              name={"apiaccounts__borkLiteSecret"}
              tDefault={"Lite Secret"}
              tKey={"vestigingen.form.bork.label.borkLiteSecret"}
            />
            <FormTextTC
              name={"apiaccounts__borkLitePriceKey"}
              tDefault={"Lite Price Code Key"}
              tKey={"vestigingen.form.bork.label.borkLitePriceKey"}
            />
            <FormTextTC
              name={"apiaccounts__borkLiteCenterKey"}
              tDefault={"Lite center key"}
              tKey={"vestigingen.form.bork.label.borkLiteCenterKey"}
            />
            {/*  <FormSwitchTC
              name={"mplusOCnt"}
              tKey={"vestigingen.form.mplusapi.label.mplusOCnt"}
              tDefault={"Send OCnt"}
            />*/}
            <FormAsyncTC
              async={{
                url:
                  "core/producten/search?fields=id as value, naam as label&per_page=50&sort_field=naam&vestiging_id=" +
                  menukaartVestigingId,
                searchField: "naam",
              }}
              key={"apiaccounts__serviceProduct_id" + menukaartVestigingId}
              name={"apiaccounts__serviceProduct_id"}
              nullable={true}
              tDefault={"Bediening (service)"}
              tKey={"vestigingen.form.apiaccounts.label.serviceProduct_id"}
            />
            <FormAsyncTC
              async={{
                url:
                  "core/producten/search?fields=id as value, naam as label&per_page=50&sort_field=naam&vestiging_id=" +
                  menukaartVestigingId,
                searchField: "naam",
              }}
              key={"apiaccounts__billProduct_id" + menukaartVestigingId}
              name={"apiaccounts__billProduct_id"}
              nullable={true}
              tDefault={"Rekening (service)"}
              tKey={"vestigingen.form.apiaccounts.label.billProduct_id"}
            />
            <FormSwitchTC
              name={"borkCloseTable"}
              tDefault={"Close table"}
              tKey={"vestigingen.form.bork.label.borkCloseTable"}
            />
            <FormTextTC name={"borkCloseID"} tDefault={"Close ID"} tKey={"vestigingen.form.bork.label.borkCloseID"} />
            <FormSwitchTC
              name={"apiaccounts__trivecFLasPR"}
              tDefault={"Customfields product"}
              tKey={"vestigingen.form.bork.label.productCustomfield"}
            />
            <FormSwitchTC
              name={"mplusOCnt"}
              tDefault={"Sent OCnt as memo"}
              tKey={"vestigingen.form.bork.label.mplusOcnt"}
            />
            <FormSwitchTC
              name={"apiaccounts__sentDTS"}
              tDefault={"Sent DTS as memo"}
              tKey={"vestigingen.form.bork.label.sentDTS"}
            />
            <FormTextTC
              name={"apiaccounts__trivecMapCustomFieldNameToPrepNumber"}
              tDefault={"Map a customfield value to PrepNumber (e.g. pagerNr)"}
              tKey={"apiaccounts__trivecMapCustomFieldNameToPrepNumber"}
            />
            <FormTextTC
              name={"apiaccounts__trivecFLprID"}
              tDefault={"Product ID (TRV)"}
              tKey={"vestigingen.form.bork.label.productIdMemo"}
            />
            <FormSwitchTC
              name={"apiaccounts__borkDatumTijdNaam"}
              tDefault={"DTS bij naam"}
              tKey={"vestigingen.form.bork.label.dtsByName"}
            />
            <FormSwitchTC
              name={"useWithoutTableOverlappingMiddleware"}
              tDefault={"Don't overlap table request"}
              tKey={"vestigingen.form.overige.label.useWithoutTableOverlappingMiddleware"}
            />
            <FormSwitchTC
              name={"custom_data.syncv2.trivec_lite.menu_option_zero_price"}
              tKey={"Force zero price for menu options"}
            />
            <FormSwitchTC
              name={"oChecker"}
              tDefault={"Order checker"}
              tKey={"vestigingen.form.overige.label.orderChecker"}
            />
            <FormSelectTC
              name={"custom_data.syncv2.trivec_lite.vat_group"}
              options={vatOptions}
              tKey={"Lite VAT group"}
              defaultValue={"1"}
            />
          </GridLegacy>

          <MenuSyncSettings />
          <GridLegacy container spacing={1} style={{ maxWidth: 1400 }}>
            <GridLegacy item xs={12}>
              <h3>
                <TranslationWrapper
                  tDefault={"Payment IDS for using multiple payment methods"}
                  tKey={"vestigingen.form.extra_settings.payments.json"}
                />
              </h3>
            </GridLegacy>
            <GridLegacy item xs={12}>
              <Buttonbar disableAll={showInputForm} onClick={handleButtonClick} />
            </GridLegacy>
          </GridLegacy>

          <GridLegacy container spacing={1} style={{ maxWidth: 1400 }}>
            <GridLegacy item xs={12}>
              {form.current}
            </GridLegacy>
          </GridLegacy>
          <Overzicht customFields={extra_settings__paymentApiIdsValue} disableAll={showInputForm} onDelete={onDelete} />
          <GridLegacy container spacing={1} style={{ maxWidth: 1400 }}>
            <GridLegacy item xs={12}>
              <h3>
                <TranslationWrapper tDefault={"JSON"} tKey={"vestigingen.form.customfields.headers.json"} />
              </h3>
            </GridLegacy>
            <FormJson
              name={"extra_settings__paymentApiIds"}
              tDefault={"JSON"}
              tKey={"vestigingen.form.customfields.headers.json"}
            />
          </GridLegacy>
          {useAccountServerValue ? (
            <>
              <GridLegacy container spacing={1} style={{ maxWidth: 1400 }}>
                <GridLegacy item xs={12}>
                  <h3>
                    <TranslationWrapper
                      tDefault={"Account type to price key mapping"}
                      tKey={"vestigingen.form.extra_settings.account_to_pricekey.json"}
                    />
                  </h3>
                </GridLegacy>
                <GridLegacy item xs={12}>
                  <ButtonbarAccounts disableAll={showInputFormAccounts} onClick={handleButtonAccountsClick} />
                </GridLegacy>
              </GridLegacy>

              <GridLegacy container spacing={1} style={{ maxWidth: 1400 }}>
                <GridLegacy item xs={12}>
                  {formAccounts.current}
                </GridLegacy>
              </GridLegacy>

              <OverzichtAccounts
                customFields={extra_settings__account_to_pricekey}
                disableAll={showInputFormAccounts}
                onDelete={onDeleteAccounts}
              />
              <GridLegacy container spacing={1} style={{ maxWidth: 1400 }}>
                <GridLegacy item xs={12}>
                  <h3>
                    <TranslationWrapper tDefault={"JSON"} tKey={"vestigingen.form.customfields.headers.json"} />
                  </h3>
                </GridLegacy>

                <FormJson
                  name={"extra_settings__account_to_pricekey"}
                  tDefault={"JSON"}
                  tKey={"vestigingen.form.customfields.headers.json"}
                />
              </GridLegacy>

              <GridLegacy container spacing={1} style={{ maxWidth: 1400 }}>
                <GridLegacy item xs={12}>
                  <h3>
                    <TranslationWrapper
                      tDefault={"Account server custom headers"}
                      tKey={"vestigingen.form.extra_settings.account_to_pricekey.headers"}
                    />
                  </h3>
                </GridLegacy>
                <GridLegacy item xs={12}>
                  <ButtonbarHeaders disableAll={showInputFormHeaders} onClick={handleButtonHeadersClick} />
                </GridLegacy>
              </GridLegacy>

              <GridLegacy container spacing={1} style={{ maxWidth: 1400 }}>
                <GridLegacy item xs={12}>
                  {formHeaders.current}
                </GridLegacy>
              </GridLegacy>

              <OverzichtHeaders
                customFields={extra_settings__account_headers}
                disableAll={extra_settings__account_headers}
                onDelete={onDeleteHeaders}
              />
              <GridLegacy container spacing={1} style={{ maxWidth: 1400 }}>
                <GridLegacy item xs={12}>
                  <h3>
                    <TranslationWrapper tDefault={"JSON"} tKey={"vestigingen.form.customfields.headers.json"} />
                  </h3>
                </GridLegacy>
                <FormJson
                  name={"extra_settings__account_headers"}
                  tDefault={"JSON"}
                  tKey={"vestigingen.form.customfields.headers.json"}
                />
              </GridLegacy>
            </>
          ) : null}
        </CardBody>
      </Card>
    </div>
  );
}

export default Bork;
